import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const Filters = ({ productAndServiceData, onFilter }) => {
  const allData = productAndServiceData;

  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState([]);
  const [isAnyFilterSelected, setIsAnyFilterSelected] = useState(false);

  useEffect(() => {
    let filtered = productAndServiceData;

    if (selectedTeams.length > 0) {
      filtered = filtered.filter((item) => 
        selectedTeams.map(team => 
          team.toLowerCase()).includes(item.team.toLowerCase())
        );    
      }

    if (selectedOffering.length > 0) {
      filtered = filtered.filter((item) =>
        selectedOffering.map(offering => 
          offering.toLowerCase()).includes(item.type.toLowerCase())
      );
    }

    onFilter(filtered);
  }, [selectedTeams, selectedOffering, productAndServiceData]);

  useEffect(() => {
    if (selectedTeams.length > 0 || selectedOffering.length > 0) {
      setIsAnyFilterSelected(true);
    } else {
      setIsAnyFilterSelected(false);
    }
  }, [selectedTeams, selectedOffering]);

  const handleTeamChange = (team) => {
    setSelectedTeams((prev) =>
      prev.includes(team) ? prev.filter((t) => t !== team) : [...prev, team]
    );
  };

  const handleOfferingChange = (team) => {
    setSelectedOffering((prev) =>
      prev.includes(team) ? prev.filter((t) => t !== team) : [...prev, team]
    );
  };

  const handleClearFilters = () => {
    setSelectedTeams([]);
    setSelectedOffering([]);
    setIsAnyFilterSelected(false);
    onFilter(productAndServiceData);
  };

  return (
    <div className="card">
      <div className="card-body">
        {isAnyFilterSelected && (
          <div className="d-flex align-items-center mb-3">
            <button
              className="btn btn-outline-secondary"
              onClick={handleClearFilters}
            >
              <IoClose className="fs-4" /> Clear All Filters
            </button>
          </div>
        )}

        <div className="mb-3">
          <h6>By Offering</h6>
          <div className="d-flex flex-column">
            <div className="form-check">
              <input
                type="checkbox"
                id="products"
                className="form-check-input"
                checked={selectedOffering.includes("Product")}
                onChange={() => handleOfferingChange("Product")}
              />
              <label className="form-check-label" htmlFor="products">
                Products
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="services"
                className="form-check-input"
                checked={selectedOffering.includes("Service")}
                onChange={() => handleOfferingChange("Service")}
              />
              <label className="form-check-label" htmlFor="services">
                Services
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="tools"
                className="form-check-input"
                checked={selectedOffering.includes("Tools")}
                onChange={() => handleOfferingChange("Tools")}
              />
              <label className="form-check-label" htmlFor="tools">
                Tools
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="consulting"
                className="form-check-input"
                checked={selectedOffering.includes("ConsultingSolutions")}
                onChange={() => handleOfferingChange("ConsultingSolutions")}
              />
              <label className="form-check-label" htmlFor="consulting">
                Consulting Solutions
              </label>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h6>By Team</h6>
          <div className="d-flex flex-column">
            <div className="form-check">
              <input
                type="checkbox"
                id="pca"
                className="form-check-input"
                checked={selectedTeams.includes("PCA")}
                onChange={() => handleTeamChange("PCA")}
              />
              <label className="form-check-label" htmlFor="pca">
                PCA
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="finops"
                className="form-check-input"
                checked={selectedTeams.includes("FinOps")}
                onChange={() => handleTeamChange("FinOps")}
              />
              <label className="form-check-label" htmlFor="finops">
                Finops
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="oe"
                className="form-check-input"
                checked={selectedTeams.includes("OE")}
                onChange={() => handleTeamChange("OE")}
              />
              <label className="form-check-label" htmlFor="oe">
                OE
              </label>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h6>By Cloud Platform</h6>
          <div className="d-flex flex-column">
            <div className="form-check">
              <input type="checkbox" id="aws" className="form-check-input" />
              <label className="form-check-label" htmlFor="aws">
                AWS
              </label>
            </div>
            <div className="form-check">
              <input type="checkbox" id="azure" className="form-check-input" />
              <label className="form-check-label" htmlFor="azure">
                Azure
              </label>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h6>By Service Category</h6>
          <div className="d-flex flex-column">
            <div className="form-check">
              <input type="checkbox" id="devops" className="form-check-input" />
              <label className="form-check-label" htmlFor="devops">
                DevOps
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="networking"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="networking">
                Networking
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="security"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="security">
                Security
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="analytics"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="analytics">
                Analytics
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="dashboard"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="dashboard">
                Dashboard
              </label>
            </div>
            <div className="form-check">
              <input type="checkbox" id="api" className="form-check-input" />
              <label className="form-check-label" htmlFor="api">
                API
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="storage"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="storage">
                Storage
              </label>
            </div>
            <div className="form-check">
              <input type="checkbox" id="access" className="form-check-input" />
              <label className="form-check-label" htmlFor="access">
                Access
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                id="administration"
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="administration">
                Administration
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
